"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HybridConfigurationStore = void 0;
const application_logger_1 = require("../application-logger");
class HybridConfigurationStore {
    constructor(servingStore, persistentStore) {
        this.servingStore = servingStore;
        this.persistentStore = persistentStore;
        this.environment = null;
        this.configFetchedAt = null;
        this.configPublishedAt = null;
        this.format = null;
    }
    /**
     * Initialize the configuration store by loading the entries from the persistent store into the serving store.
     */
    async init() {
        if (!this.persistentStore) {
            return;
        }
        if (!this.persistentStore.isInitialized()) {
            /**
             * The initial remote request to the remote API failed
             * or never happened because we are in the cool down period.
             *
             * Shows a log message that the assignments served from the serving store
             * may be stale.
             */
            application_logger_1.logger.warn(`${application_logger_1.loggerPrefix} Persistent store is not initialized from remote configuration. Serving assignments that may be stale.`);
        }
        const entries = await this.persistentStore.entries();
        this.servingStore.setEntries(entries);
    }
    isInitialized() {
        return this.servingStore.isInitialized() && (this.persistentStore?.isInitialized() ?? true);
    }
    async isExpired() {
        const isExpired = await this.persistentStore?.isExpired();
        return isExpired ?? true;
    }
    get(key) {
        if (!this.servingStore.isInitialized()) {
            application_logger_1.logger.warn(`${application_logger_1.loggerPrefix} getting a value from a ServingStore that is not initialized.`);
        }
        return this.servingStore.get(key);
    }
    entries() {
        return this.servingStore.entries();
    }
    getKeys() {
        return this.servingStore.getKeys();
    }
    async setEntries(entries) {
        if (this.persistentStore) {
            // Persistence store is now initialized and should mark itself accordingly.
            await this.persistentStore.setEntries(entries);
        }
        this.servingStore.setEntries(entries);
        return true;
    }
    setEnvironment(environment) {
        this.environment = environment;
    }
    getEnvironment() {
        return this.environment;
    }
    getConfigFetchedAt() {
        return this.configFetchedAt;
    }
    setConfigFetchedAt(configFetchedAt) {
        this.configFetchedAt = configFetchedAt;
    }
    getConfigPublishedAt() {
        return this.configPublishedAt;
    }
    setConfigPublishedAt(configPublishedAt) {
        this.configPublishedAt = configPublishedAt;
    }
    getFormat() {
        return this.format;
    }
    setFormat(format) {
        this.format = format;
    }
}
exports.HybridConfigurationStore = HybridConfigurationStore;
//# sourceMappingURL=hybrid.store.js.map